import { Koi } from '@ksyos/koi';
import { emailSchema } from './schemas/emailSchema';
import { phoneNumberNoErrorSchema } from './schemas/phoneNumberSchema';

export interface IPatientContactInfoDraft {
    city?: string | null;
    country?: string | null;
    emailadres: string | null;
    homePhoneNumber: string | null;
    houseNumber?: string | null;
    houseNumberSuffix?: string | null;
    mobileNumber: string | null;
    street?: string | null;
    zip?: string | null;
}

export interface IPatientContactInfoFinal extends IPatientContactInfoDraft {
    emailadres: string;
}

export const patientContactInfoFinal = Koi.object().keys({
    emailadres: emailSchema.disallow(null),
    homePhoneNumber: phoneNumberNoErrorSchema.allow(null),
    mobileNumber: phoneNumberNoErrorSchema.when('homePhoneNumber', {
        is: null,
        otherwise: Koi.allow(null),
        then: Koi.disallow(null),
    }),
});

export const patientContactInfoDraft = Koi.object({
    emailadres: Koi.string().max(1000).allow(null),
    homePhoneNumber: Koi.string().max(1000).allow(null),
    mobileNumber: Koi.string().max(1000).allow(null),
});
